import React from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "../mock/data";
import { Mail, Phone, MapPin } from "lucide-react";

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Refund Policy", to: "/refund-policy" },
  { label: "Shipping Policy", to: "/shipping-policy" },
  { label: "Cookie Policy", to: "/cookie-policy" },
  { label: "Disclaimer", to: "/disclaimer" }
];

const companyLinks = [
  { label: "About Us", to: "/about" },
  { label: "Contact Us", to: "/contact" },
  { label: "FAQ", to: "/#faq" },
  { label: "Pricing", to: "/#pricing" }
];

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="inline-flex items-center mb-4">
            <img
              src="/brand/huntheal-logo.png"
              alt={`${COMPANY.brand} logo`}
              className="h-10 w-auto rounded-md"
            />
          </Link>
          <p className="text-sm text-slate-400 leading-relaxed">
            Advanced Android antivirus that keeps your phone fast, private, and secure — 24/7. Built for real users, backed by expert support.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <span className="text-[10px] uppercase tracking-widest bg-emerald-500/10 text-emerald-300 border border-emerald-500/20 rounded-full px-2 py-1">ISO 27001</span>
            <span className="text-[10px] uppercase tracking-widest bg-emerald-500/10 text-emerald-300 border border-emerald-500/20 rounded-full px-2 py-1">GDPR</span>
            <span className="text-[10px] uppercase tracking-widest bg-emerald-500/10 text-emerald-300 border border-emerald-500/20 rounded-full px-2 py-1">SOC 2</span>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-widest mb-4">Company</h4>
          <ul className="space-y-2.5 text-sm">
            {companyLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-emerald-300 transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-widest mb-4">Legal</h4>
          <ul className="space-y-2.5 text-sm">
            {legalLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-emerald-300 transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm uppercase tracking-widest mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 mt-0.5 text-emerald-400" />
              <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-emerald-300">{COMPANY.phone}</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 mt-0.5 text-emerald-400" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-emerald-300">{COMPANY.email}</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 mt-0.5 text-emerald-400" />
              <span className="text-slate-400">
                {COMPANY.address.line2}, {COMPANY.address.city} {COMPANY.address.zip}, {COMPANY.address.country}
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} {COMPANY.brand}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
